import { cn } from "../../lib/cn";

const spinnerClass =
  "inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent";

/** Decorative by default. Pass `label` when the spinner is the only sign that something is loading. */
export function Spinner({ className, label }: { className?: string; label?: string }) {
  if (label) {
    return <span role="status" aria-label={label} className={cn(spinnerClass, className)} />;
  }
  return <span aria-hidden className={cn(spinnerClass, className)} />;
}
